import type { ReactNode } from 'react'
import { Sidebar } from '@/organisms/Sidebar'
import { Topbar } from '@/organisms/Topbar'

export type AgencyShellProps = {
  children?: ReactNode
}

export function AgencyShell({ children }: AgencyShellProps) {
  return (
    <div className="grid min-h-screen grid-cols-1 lg:grid-cols-[var(--spacing-sidebar)_minmax(0,1fr)]">
      <Sidebar />
      <div className="flex min-w-0 flex-col">
        <Topbar />
        <main className="flex-1 px-7 py-5 max-md:px-4">{children}</main>
      </div>
    </div>
  )
}
